import { render } from "./Updated.vue?vue&type=template&id=d1d763ec"
import script from "./Updated.vue?vue&type=script&lang=js"
export * from "./Updated.vue?vue&type=script&lang=js"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__